





































export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    pccPatient: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    patientLocation() {
      if (!this.pccPatient) return null
      return this.pccPatient.floorDesc || this.pccPatient.roomDesc || this.pccPatient.bedDesc
        ? `${this.pccPatient.floorDesc} ${this.pccPatient.roomDesc} - ${this.pccPatient.bedDesc}`
        : '(unknown)'
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    confirmAssignPatientAction() {
      this.$emit('confirmAssignPatientAction')
    },
  },
}
